import type { TodayScope } from '@crm/contracts';
import { TODAY_BLOCK_CAP, TODAY_BLOCK_MAX } from '@crm/contracts';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

export const todayKeys = {
  all: ['today'] as const,
  page: (scope: TodayScope, limit: number) => [...todayKeys.all, scope, limit] as const,
};

/**
 * The whole page, in one request.
 *
 * `staleTime` is deliberately short rather than zero: the page is opened,
 * worked top to bottom and left open, and every write on it invalidates the
 * key anyway. What this avoids is a refetch on every window focus while
 * somebody is dialling from a second tab.
 */
export function useToday(scope: TodayScope, showAll: boolean) {
  const limit = showAll ? TODAY_BLOCK_MAX : TODAY_BLOCK_CAP;
  return useQuery({
    queryKey: todayKeys.page(scope, limit),
    queryFn: () => api.today.get({ scope, limit }),
    staleTime: 30_000,
  });
}
